import type {
  RetailerSellarDistributionMetaUpsertTimePreferenceRequestType,
  RetailerSellarDistributionMetaUpsertTimePreferenceResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBuyerSellarDistributionMetaUpsertTimePreference = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (
      data: RetailerSellarDistributionMetaUpsertTimePreferenceRequestType,
    ) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: "retailer-sellar-distribution-meta/time-preference",
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as RetailerSellarDistributionMetaUpsertTimePreferenceResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierRelationships,
        ],
      });
    },
  });
};
